module.exports = __webpack_public_path__ + "img/parche__transparente_4.bf749420.png";